import { useDispatch } from 'react-redux';
import { useCallback, useMemo } from 'react';

import { downloadDocument, printDocument } from '../../../../store/documents/documents.actions';
import { printPickList } from '../../../../store/printing/print.actions';
import { usePrintSettings } from '../../core/hooks';
import { DocumentType } from '../../../../enums/document-type';
import { usePicklistsFeatureGate } from '../../../../feature-gates/use-picklists-feature-gate';

export const usePickList = ({ fulfillments }) => {
  const dispatch = useDispatch();
  const { isFeatureEnabled } = usePicklistsFeatureGate();
  const isDisabled = !isFeatureEnabled || fulfillments.length === 0;
  const printSettings = usePrintSettings(DocumentType.PickList.printSettingKey);
  const fulfillmentPlanIds = useMemo(() => fulfillments.map((f) => f.fulfillmentPlanId), [fulfillments]);

  const onClick = useCallback(() => {
    dispatch(printPickList(fulfillmentPlanIds));
  }, [dispatch, fulfillmentPlanIds]);

  const onDownload = useCallback(() => {
    dispatch(downloadDocument(DocumentType.PickList, fulfillmentPlanIds));
  }, [dispatch, fulfillmentPlanIds]);

  const onPrint = useCallback(() => {
    dispatch(printDocument(DocumentType.PickList, fulfillmentPlanIds, printSettings));
  }, [dispatch, fulfillmentPlanIds, printSettings]);

  return useMemo(
    () => ({
      isFeatureEnabled,
      isDisabled,
      onClick,
      onDownload,
      onPrint,
    }),
    [isDisabled, isFeatureEnabled, onClick, onDownload, onPrint],
  );
};
